module.exports = __webpack_public_path__ + "static/img/3业务布局-印花.02e2ca15.png";